// extracted by mini-css-extract-plugin
export default {"row":"ForthScreen_row__VI22e","title":"ForthScreen_title__35pUX","description":"ForthScreen_description__RUpwg"};